"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.identityServiceUrl = function (env, serviceType) {
    var availableVirtualIdentityEnvs = ['local', 'stage', 'staging', 'dev', 'development'];
    var url = availableVirtualIdentityEnvs.indexOf(env) >= 0
        ? 'https://stage.identity.kr.riotgames.com'
        : 'https://identity.kr.riotgames.com';
    return url + "/ko_KR?serviceType=" + serviceType;
};
exports.isIE = function () {
    var agent = navigator.userAgent.toLowerCase();
    return (navigator.appName == 'Netscape' && (agent.indexOf('trident') != -1 || agent.indexOf('edge/') != -1))
        || (agent.indexOf("msie") != -1);
};
//# sourceMappingURL=common.js.map